import template from './client-report.html';
import controller from './client-report.controller';

let clientReportComponent = {
  bindings: {},
  template,
  controller
};

export default clientReportComponent;



// WEBPACK FOOTER //
// ./client/app/components/client/client-report.component.js